<template>
  <v-form ref="form" v-model="valid" :lazy-validation="lazy">
    <v-card flat color="transparent">
      <v-card-title class="font-weight-bold q-message">{{ `${qNumber ? qNumber + '. ' : ''} ${qMessage}` }}</v-card-title>
      <div class="d-flex pl-10">
        <div style="width: 80%">
          <v-text-field
            class="mx-5"
            v-model="answer"
            :rules="emailType ? [rules.required, rules.emailRules] : [rules.required]"
            :counter="maxText"
            :label="qTitle"
            :placeholder="`여기에 ${qTitle} 써주세요`"
            required
            @keyup.enter="confirm"
          />
        </div>
        <div v-if="qPredicate.length > 0" class="headline pt-5">
          <span>{{ qPredicate }}</span>
        </div>
      </div>
    </v-card>
    <v-card-actions>
      <v-btn color="#5878b8" :disabled="!valid" width="100" class="headline white--text" @click="confirm">
        확인
        <v-icon right>mdi-check</v-icon>
      </v-btn>
      <!-- <v-btn text color="grey" class="title" v-if="valid">
        Enter 키를 눌러주세요
        <v-icon>mdi-keyboard-return</v-icon>
      </v-btn> -->
    </v-card-actions>
  </v-form>
</template>

<script>
import { mapMutations, mapState, mapActions } from 'vuex'
export default {
  props: {
    qCategory: { type: String, default: '' },
    qId: {
      type: String,
      default: '',
    },
    qNumber: {
      type: String,
      default: 'qNumber',
    },
    qMessage: {
      type: String,
      default: '',
    },
    qTitle: {
      type: String,
      default: '',
    },
    qPredicate: {
      type: String,
      default: '',
    },
    emailType: {
      type: Boolean,
      default: false,
    },
    maxText: {
      type: Number,
      default: 10,
    },
  },
  mounted() {
    if (this.qId === '일반-기본-1') this.answer = this.userNick
    if (this.qId === '일반-기본-2') this.answer = this.userEmail
    const ans = (this[this.qCategory.toLowerCase()] || {})[this.qId]
    // console.log(ans)
    if (ans) {
      this.answer = ans.value
      this.isCompleted = true
    }
  },
  data() {
    return {
      valid: true,
      answer: '',
      lazy: false,
      rules: {
        required: (value) => !!value || '꼭 써주셔야 합니다',
        counter: (value) => value.length <= 20 || '최대 20 글자까지 해주세요',
        emailRules: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
      },
    }
  },
  methods: {
    ...mapActions(['submit']),
    ...mapMutations(['setUserEmail', 'setUserNick', 'setMaster', 'setFinance', 'setCareer']),
    confirm() {
      this.valid && this.$emit('nextSlide')
      // if (this.qId === '일반-기본-1') this.setUserNick(this.answer)
      // if (this.qId === '일반-기본-2') this.setUserEmail(this.answer)

      const payload = {
        id: this.qId,
        question: this.qMessage,
        category: this.qCategory,
        subCategory: this.subCategory,
        type: this.qType,
        value: this.answer,
      }

      if (this.qCategory === 'Master') this.setMaster(payload)
      else if (this.qCategory === 'Finance') this.setFinance(payload)
      else if (this.qCategory === 'Career') this.setCareer(payload)
      this.submit()
    },
  },
  computed: {
    ...mapState(['userEmail', 'userNick', 'master', 'finance', 'career', 'action']),
  },
}
</script>

<style></style>
